import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { dbg } from '@utils/dbg';

(window as any).dbg = dbg;

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
